import Typography from '@mui/material/Typography';

const ColoradoLoginHeader = () => {
  return (
    <Typography variant="body1">
      Welcome to ECHO Demo. Please enter your login info or create an account, so you can be a part of making health
      knowledge ECHO nationwide and beyond.
    </Typography>
  );
};

export default ColoradoLoginHeader;
